// create FSA find conversation request action
export const FIND_CHAT_CONVERSATION_REQUEST = 'FIND_CHAT_CONVERSATION_REQUEST';

export const findChatConversationRequest = ({ id }) => ({
    type: FIND_CHAT_CONVERSATION_REQUEST,
    payload: {
        id,
    },
});
